import React from 'react';
import './StatisticsItemList.scss';

function StatisticsItemList(props) {
  const {
    items = [],
    title = null,
    columnNames = [],
    numberField = 'orderCount',
    showAllForReport = false,
    showErrorsList = false,
    itemListHeight = false,
  } = props;

  return (
    <div className='items-container h-100'>
      <div className='items d-flex flex-column gap-1 h-100'>
        <div className='title pt-2 pb-1'>
          <span className='analytic-title'>{title}</span>
        </div>
        {items?.length > 0 && (
          <div className='col-12 d-flex col-header p-2 gap-2 rounded'>
            {columnNames?.length > 0 && columnNames?.length === Object.keys(items[0])?.length
              ? columnNames?.map((element, index) => {
                  return (
                    <div
                      className={`column col fw-bold text-nowrap ${
                        index === columnNames.length - 1 && numberField !== 'orderCount'
                          ? 'text-end'
                          : ''
                      }`}
                      key={index}
                    >
                      {element}
                    </div>
                  );
                })
              : Object.keys(items[0])?.map((element, index) => {
                  return (
                    <div className='column col fw-bold text-center text-nowrap' key={index}>
                      {element}
                    </div>
                  );
                })}
          </div>
        )}

        <div
          className={`col-12 d-flex flex-column gap-1 ${
            showAllForReport ? 'h-100' : 'items-list scroll-styled'
          } ${itemListHeight ? ' items-list-child' : ''}`}
        >
          {items
            ?.slice()
            ?.sort((a, b) => b?.[numberField] - a?.[numberField])
            ?.map((item) => {
              const itemKey = item.id || item.itemName || Math.random();
              return showErrorsList === false ? (
                <div className='col-12 row-value d-flex p-2 gap-2 rounded' key={itemKey}>
                  <div className={`text-start column col `}>{item['itemName']}</div>
                  <div className={`text-end column col `}>{item?.[numberField] || 0}</div>
                </div>
              ) : (
                <div className='col-12 row-value d-flex p-2 gap-2 rounded' key={itemKey}>
                  {columnNames?.map((columnName, columnIndex) => {
                    return numberField !== columnName ? (
                      <div
                        className={`text-start column text-break px-2 ${
                          columnNames?.length >= 3 ? 'col-4 ' : 'col '
                        } ${Array.isArray(item?.[columnName]) ? 'd-flex flex-column ' : ''}`}
                        key={columnIndex}
                      >
                        {Array.isArray(item[columnName])
                          ? item?.[columnName]?.map((error, errorIndex) => {
                              return (
                                <div className='col-12' key={errorIndex}>
                                  {error}
                                </div>
                              );
                            })
                          : item?.[columnName]}
                      </div>
                    ) : (
                      <div className={`text-end column col `}>
                        {Array.isArray(item[numberField])
                          ? item?.[numberField]?.map((count, countIndex) => {
                              return (
                                <div className='col-12' key={countIndex}>
                                  {count}
                                </div>
                              );
                            })
                          : item?.[numberField] || 0}
                      </div>
                    );
                  })}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}

export default StatisticsItemList;
